import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { candidateRedirect } from "./candidate.guard";

/** Telas exclusivas da gerente (cadastro de professoras, financeiro). */
export const managerGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isLoggedIn()) {
    router.navigate(["/login"]);
    return false;
  }

  const candidate = candidateRedirect();
  if (candidate) return candidate;

  if (authService.isManager()) {
    return true;
  }

  router.navigate(["/teacher-dashboard"]);
  return false;
};
